import React from "react";
import updateTopNineOrder from "../../../libs/updateTopNineOrder";

class UpdateTopNineHandler extends React.Component {
  state = {
    error: null,
  };
  updateTopNineOrder = ({ token, method }) =>
    updateTopNineOrder({
      id: this.props.id,
      stripe: {
        token,
      },
    })
      .then(res => {
        if (window.gtag) window.gtag("event", "purchase_watermark");
        window.gtag("event", "purchase", {
          transaction_id: res.data.id,
          value: res.data.cost,
          currency: "USD",
        });
      })
      .catch(error => {
        this.setState({ error: error.message });
        throw error;
      });
  render() {
    return this.props.children({
      updateTopNineOrder: this.updateTopNineOrder,
      error: this.state.error,
      ...this.props,
    });
  }
}

export default UpdateTopNineHandler;
